import React from 'react'

const ClockIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='28'
    height='28'
    viewBox='0 0 28 28'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M17.85 19.4833L19.4833 17.8499L15.1667 13.5333V8.16659H12.8333V14.4666L17.85 19.4833ZM14 25.6666C12.3861 25.6666 10.8695 25.3603 9.45001 24.7478C8.03057 24.1353 6.79584 23.3041 5.74584 22.2541C4.69584 21.2041 3.86459 19.9694 3.25209 18.5499C2.63959 17.1305 2.33334 15.6138 2.33334 13.9999C2.33334 12.386 2.63959 10.8694 3.25209 9.44992C3.86459 8.03047 4.69584 6.79575 5.74584 5.74575C6.79584 4.69575 8.03057 3.8645 9.45001 3.252C10.8695 2.6395 12.3861 2.33325 14 2.33325C15.6139 2.33325 17.1306 2.6395 18.55 3.252C19.9695 3.8645 21.2042 4.69575 22.2542 5.74575C23.3042 6.79575 24.1354 8.03047 24.7479 9.44992C25.3604 10.8694 25.6667 12.386 25.6667 13.9999C25.6667 15.6138 25.3604 17.1305 24.7479 18.5499C24.1354 19.9694 23.3042 21.2041 22.2542 22.2541C21.2042 23.3041 19.9695 24.1353 18.55 24.7478C17.1306 25.3603 15.6139 25.6666 14 25.6666ZM14 23.3333C16.5861 23.3333 18.7882 22.4242 20.6063 20.6062C22.4243 18.7881 23.3333 16.586 23.3333 13.9999C23.3333 11.4138 22.4243 9.21172 20.6063 7.39367C18.7882 5.57561 16.5861 4.66659 14 4.66659C11.4139 4.66659 9.21182 5.57561 7.39376 7.39367C5.5757 9.21172 4.66668 11.4138 4.66668 13.9999C4.66668 16.586 5.5757 18.7881 7.39376 20.6062C9.21182 22.4242 11.4139 23.3333 14 23.3333Z'
      fill='currentcolor'
    />
  </svg>
)

export default ClockIcon
